import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedProductList, ConnectedSpaceDetailRenderer, ConnectedSpaceDetailWrapper } from '../../../connectors';
import { MeilisearchStoreKey } from '../../../entities/@search/Meilisearch/Meilisearch';
import { inStockSort } from '../../../entities/Sort/Sort';

import './SpaceDetailPage.scss';

interface SpaceDetailPageProps {
    className?: string;
}

export const SpaceDetailPage: FC<SpaceDetailPageProps> = ({
    className = '',
}): ReactElement => (
    <ConnectedSpaceDetailWrapper>
        {({ baseFilter }) => (
            <Page className={`space-detail-page ${className}`}>
                <ConnectedSpaceDetailRenderer />

                {baseFilter && (
                    <ConnectedProductList
                        showFilterBar
                        storeKey={MeilisearchStoreKey.spaceDetail}
                        baseFilter={baseFilter}
                        baseSort={inStockSort}
                        className="space-detail-page__block"
                    />
                )}
            </Page>
        )}
    </ConnectedSpaceDetailWrapper>
);
